module.exports = __webpack_public_path__ + "img/poly-3.0b10a507.png";